// extracted by mini-css-extract-plugin
module.exports = {"logo":"terms_logo__1zoTK","title":"terms_title__2znNW","link":"terms_link__3L5JF","button":"terms_button__1SgOk"};